'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckDate = function () {
  function CheckDate() {
    _classCallCheck(this, CheckDate);
  }

  _createClass(CheckDate, null, [{
    key: 'Check',
    value: function Check(date, lang) {
      if (date !== null && date !== undefined && lang !== null && lang !== undefined) {
        var regEx = '';
        switch (lang) {
          case 'de':
            {
              regEx = /^(0?[1-9]|[12][0-9]|3[01])[.](0?[1-9]|1[012])[.](19|20)?[\d]{2}$/gi;
              break;
            }
          case 'en':
            {
              regEx = /^(0?[1-9]|1[012])[/](0?[1-9]|[12][0-9]|3[01])[/](19|20)?[\d]{2}$/gi;
              break;
            }
          default:
            break;
        }
        var arr = date.match(regEx);

        if (arr === null) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  }]);

  return CheckDate;
}();

exports.default = CheckDate;